import { BestPriceGuaranteeCard } from "@apac/components/ui";
import { useBooleanFlag } from "@apac/feature-flags";
import { usePriceDropPredictionDetails } from "@apac/hooks";
import { FareCombinationBanner } from "@b2bportal/core-flights/overridable";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ENABLE_FLIGHT_FX_DISCLAIMER, FeatureFlagNames } from "@hsbc/utilities";
import { PriceBreakdownLineItem as LineItem } from "../PriceBreakdownLineItem";
import { usePriceBreakdown } from "./hooks";
import styles from "./styles.module.scss";

export const PriceBreakdownContent = () => {
  const [block, cn] = useModuleBEM(styles, "PriceBreakdown");
  const { t } = useI18nContext();
  const enableBPG = useBooleanFlag(FeatureFlagNames.BEST_PRICE_GUARANTEE)!;

  const { priceData, tripCategoryDescription, isMultiTicket } =
    usePriceBreakdown();
  const { isPDPEligible } = usePriceDropPredictionDetails();
  return (
    <div className={block}>
      <span className={cn("title")}>{t("priceBreakdown")}</span>
      <div className={cn("description")}>{tripCategoryDescription}</div>

      {isPDPEligible && (
        <div className={cn("description")}>
          {t("bookingSummary.priceDropDescription", { numberOfDays: 10 })}
        </div>
      )}

      {enableBPG && (
        <div className={cn("best-price-guarantee")}>
          <BestPriceGuaranteeCard />
        </div>
      )}

      {isMultiTicket && (
        <div className={cn("best-price-guarantee")}>
          <FareCombinationBanner />
        </div>
      )}

      <div className={cn("price-list")}>
        {priceData.map((lineProps) => (
          <LineItem {...lineProps} key={lineProps.id} />
        ))}
        {ENABLE_FLIGHT_FX_DISCLAIMER && (
          <div className={cn("fx-disclaimer")}>
            {t("breakdown.fxRateDisclaimer")}
          </div>
        )}
      </div>
    </div>
  );
};
